
export const API_PORT = process.env.REACT_APP_API_PORT || 4000 
export const API_BASE = process.env.REACT_APP_API_BASE || `${window.location.protocol}//${window.location.hostname}:${API_PORT}`
export const API_ARCHIVOS = `${API_BASE}/archivos`
export const API_NOTIFICACIONES = `${API_BASE}/notificaciones`
export const API_URL = `${API_BASE}/graphql`
export const API_WS = process.env.REACT_APP_API_WS || `ws://${window.location.hostname}:${API_PORT}/graphql`
export const AUTH_APP = process.env.REACT_APP_AUTH_APP || `${window.location.protocol}//${window.location.hostname}:8080/auth`
export const OS_APP_ID = process.env.REACT_APP_OS_ID || '35653e58-b8eb-4f01-996b-94aa7f301521'